import { render, staticRenderFns } from "./ReportUsersItemRow.vue?vue&type=template&id=a82f29f6&scoped=true&"
import script from "./ReportUsersItemRow.vue?vue&type=script&lang=js&"
export * from "./ReportUsersItemRow.vue?vue&type=script&lang=js&"
import style0 from "./ReportUsersItemRow.vue?vue&type=style&index=0&id=a82f29f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82f29f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
